import { useEffect, useState } from 'react';

const ListRow = ({item, outterToggle}) => {
  const [selected, setSelected] = useState(item.__show);
  const [due_lv, setDueLv]      = useState(item.due_lv);

  useEffect(() => {
    setSelected(item.__show);
  }, [outterToggle]);

  return (
    <label className="table-row">
      <td className="col-oll-check">
        <input type="checkbox" checked={selected}
          onChange={e=> setSelected(item.__show=!!e.target.checked)}/>
      </td>
      <td className="col-oll-license">{ item.cd_license }</td>
      <td className="col-oll-due-lv">
        <button onClick={e=>setDueLv(item.due_lv=0)}
          className={`btn ${0!=due_lv?'white':'blue'}`}>藍</button>
        <button onClick={e=>setDueLv(item.due_lv=1)}
          className={`btn ${1!=due_lv?'white':'grey'}`}>黑</button>
        <button onClick={e=>setDueLv(item.due_lv=2)}
          className={`btn ${2!=due_lv?'white':'red'}` }>紅</button>
      </td>
    </label>
  );
}

const LicenseListModal = ({ items }) => {

  const [license, setLicense] = useState('');
  const [list, setList] = useState(
    items.sort((a,b) => {
      if (a.cd_license > b.cd_license) return  1;
      if (a.cd_license < b.cd_license) return -1;
      return 0;
    })
  );
  const [__toggle, setToggle] = useState(false);

  const selectAll = () => {
    items.forEach(x => x.__show = __toggle);
    setToggle(!__toggle);
    refreshFilter();
  }

  const refreshFilter = () => {
    let _lic = license.trim().toUpperCase();
    let list = items.filter(x => -1<x.cd_license.trim().toUpperCase().indexOf(_lic));
    setList(list);
  }

  useEffect(() => {
    refreshFilter();
  }, [license, items]);

  return (
    <>
      <div className="action-panel">
        <div className="row search-bar">
          <label className="field-row">
            <strong>車牌</strong>
            <input value={license} onChange={e=>setLicense(e.target.value.toUpperCase().trim())} />
          </label>
        </div>
        <div className="button-group">
          <button className="small blue btn" onClick={selectAll}>{ __toggle ? '全部選取' : '消除選取' }</button>
        </div>
      </div>
      <div className="license-list">
        <table className="data-table">
          <colgroup>
            <col width="36px"  id="col-oll-check" />
            <col width="200px" id="col-oll-license" />
            <col width="200px" id="col-oll-due-lv" />
          </colgroup>
          <thead>
            <tr>
              <th>選取</th>
              <th>車牌</th>
              <th>Level</th>
            </tr>
          </thead>
          <tbody>
            { list.map(x =>
              <ListRow key={x.cd_license} item={x} outterToggle={__toggle} />
            ) }
          </tbody>
        </table>
      </div>
    </>
  );
}

export default LicenseListModal;